/**
 * Consent Controller
 *
 * Simple Stimulus controller for cookie consent UI interactions.
 * ConsentManager is initialized by www.bundler.js after globals.json returns.
 * This controller just exposes actions for UI elements (footer links, etc.)
 */

import { Controller } from '@hotwired/stimulus'
import ConsentManager from 'services/consent_manager'

export default class extends Controller {
  /**
   * Show the preferences modal (for "Cookie Preferences" footer link)
   * Uses ConsentManager to ensure CookieConsent is initialized
   */
  showPreferences(event) {
    event.preventDefault()
    ConsentManager.showPreferences()
  }

  /**
   * Show the consent modal
   */
  showConsent(event) {
    event.preventDefault()
    ConsentManager.show()
  }

  /**
   * Accept all cookies
   */
  acceptAll(event) {
    event.preventDefault()
    ConsentManager.acceptAll()
  }

  /**
   * Reject all optional cookies
   */
  rejectAll(event) {
    event.preventDefault()
    ConsentManager.rejectAll()
  }
}
